import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, CanDeactivate, CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';
import * as SecureLS from 'secure-ls';
import { roleIdSix } from '../shared/constants/role.id.constants';
@Injectable({
  providedIn: 'root'
})
export class CommonGuard implements CanActivate, CanActivateChild, CanDeactivate<unknown>, CanLoad {
  constructor(private routes: Router) {}
  private ls = new SecureLS({ encodingType: 'aes' });
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (this.ls.get('token') != null) {
        if(parseInt(this.ls.get('role')) == 1 || parseInt(this.ls.get('role')) == 2 || parseInt(this.ls.get('role')) == 4 || parseInt(this.ls.get('role')) == 3|| parseInt(this.ls.get('role')) == 5 || parseInt(this.ls.get('role')) == 6) {
          if(this.ls.get("report_permission")!=undefined){
            if(this.ls.get("report_permission")==0){
              if(state.url=='/video-report' ||state.url=='/video-access-report'||state.url=='/audio-report'||state.url=='/nonaudible-report'||state.url=='/video-list'||state.url=='/summary-report'||state.url=='/daily-report'||state.url=='/report-login'||state.url=='/schedule-history'||state.url=='/student-existing'||state.url=='/approved-videos'||state.url=='/department-summary'){
                if(parseInt(this.ls.get('role')) != roleIdSix) {
                  this.routes.navigate(["/dashboard"]);
                } else {
                  this.routes.navigate(["/video-details"]);
                }
                
              }
            }
          }
          if(this.ls.get("live_class_permission")!=undefined){
            if(this.ls.get("live_class_permission")==0){
              if(state.url=='/class/onlive/list')
              if(parseInt(this.ls.get('role')) != roleIdSix) {
                this.routes.navigate(["/dashboard"]);
              } else {
                this.routes.navigate(["/video-details"]);
              }
            }
          }
          return true;
        } else {
          this.ls.remove('token');
          
          Swal.fire(
            'Expired!',
            'Unauthorized to access this page',
            'error'
          );
          this.ls.removeAll();
          this.routes.navigate(['/']);
          return false;
        }
        
      } else {
        Swal.fire(
          'Expired!',
          'Unauthorized to access this page',
          'error'
        );
        this.ls.removeAll();
        this.routes.navigate(['/']);
        return false;
      }
      
    
    return true;
  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }
}
